<template>
  <div id="registration-modal">
    <div class="row">
      <div class="col-12 logo-container">
        <img src="/static/images/logo.svg" alt="motivac.io" class="logo" />
        motivac.io
      </div>
    </div>
    <div class="row">
      <div class="col-12 main-title">{{ $t('registration.modal.title') }}</div>
    </div>
    <div class="row">
      <div class="col-12 subtitle">{{ $t('registration.modal.subtitle') }}</div>
    </div>
    <div class="row">
      <div class="col-md-6 col-12 no-gutters">
        <base-input
          @baseInputValue="emailChanged($event)"
          @enter="registrate"
          type="email"
          :placeHolder="$t('registration.modal.email.placeholder')"
          :isInvalid="!isEmailValid && email != null"
          :errorText="$t('registration.modal.email.errorText')"
          class="email-input"
          :text="email"
        />
      </div>
      <div class="col-md-6 col-12 no-gutters">
        <base-input
          @baseInputValue="passwordChanged($event)"
          @enter="registrate"
          :placeHolder="$t('registration.modal.password.placeholder')"
          :type="'password'"
          :isInvalid="!isPasswordValid && password != null"
          :errorText="$t('registration.modal.password.errorText')"
          class="password-input"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-12 no-gutters">
        <base-input
          @baseInputValue="firstNameChanged($event)"
          @enter="registrate"
          :placeHolder="$t('registration.modal.firstName.placeholder')"
          :isInvalid="!isFirstNameValid && firstName != null"
          :errorText="$t('registration.modal.firstName.errorText')"
          class="firstName-input"
        />
      </div>
      <div class="col-md-6 col-12 no-gutters">
        <base-input
          @baseInputValue="lastNameChanged($event)"
          @enter="registrate"
          :placeHolder="$t('registration.modal.lastName.placeholder')"
          :isInvalid="!isLastNameValid && lastName != null"
          :errorText="$t('registration.modal.lastName.errorText')"
          class="lastName-input"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 no-gutters">
        <base-input
          @baseInputValue="userNameChanged($event)"
          @enter="registrate"
          :placeHolder="$t('registration.modal.userName.placeholder')"
          :isInvalid="!isUserNameValid && userName != null"
          :errorText="$t('registration.modal.userName.errorText')"
          class="userName-input"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 no-gutters">
        <base-input
          @baseInputValue="companyNameChanged($event)"
          @enter="registrate"
          :placeHolder="$t('registration.modal.companyName.placeholder')"
          :isInvalid="!isCompanyNameValid && companyName != null"
          :errorText="$t('registration.modal.companyName.errorText')"
          class="companyName-input"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 no-gutters">
        <base-input
          @baseInputValue="couponCodeChanged($event)"
          @enter="registrate"
          :text="couponCode"
          :placeHolder="$t('registration.modal.couponCode.placeholder')"
          class="couponCode-input"
        />
      </div>
    </div>
    <div class="row">
      <div :class="{ 'col-12': true, hasError: hasAcceptError }">
        <checkbox id="accept" :color="'#622D90'" v-model="accepted">
          <span
            for="accept"
            class="checkbox-text"
            v-html="$t('registration.modal.acceptLabel')"
          ></span>
        </checkbox>
      </div>
    </div>
    <div class="row">
      <base-button
        @click="registrate"
        :text="$t('registration.modal.buttonText')"
        :disabled="hasError || !accepted"
        class="col-12"
      />
    </div>
    <div class="row">
      <div class="col-12">
        <span class="cancel" @click="cancel">{{
          $t('registration.modal.cancelText')
        }}</span>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions } from 'vuex';
import BaseInput from '@/components/shared/elements/BaseInput';
import BaseButton from '@/components/shared/elements/BaseButton';
import RegistrationFormMixin from '@/components/shared/users/RegistrationFormMixin';

export default {
  name: 'RegistrationModal',
  mixins: [RegistrationFormMixin],
  components: {
    BaseInput,
    BaseButton,
  },
  props: {
    initialCouponCode: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      companyName: undefined,
      couponCode: undefined,
      accepted: false,
      hasAcceptError: false,
    };
  },
  created() {
    this.couponCode = this.initialCouponCode;
    if(this.$route.query.email) {
      this.email = this.$route.query.email;
    }
  },
  computed: {
    isCompanyNameValid() {
      return this.companyName && this.companyName.length > 3;
    },
  },
  methods: {
    ...mapActions({
      registrateUser: 'users/registrate',
    }),
    async registrate() {
      if (!this.accepted) {
        this.hasAcceptError = true;
        return;
      }
      if (!this.hasError) {
        this.registrateUser({
          email: this.email,
          password: this.password,
          firstName: this.firstName,
          lastName: this.lastName,
          userName: this.userName,
          company: {
            name: this.companyName,
            couponCode: this.couponCode,
            registrationInfo: {
              period: this.$route.query.period,
              package: this.$route.query.package,
            },
          },
        })
          .then(() => {
            this.$gtag.event('registration', { method: 'Email' });
            this.$gtag.event('conversion', {
              send_to: 'AW-968163675/gX8gCNartoYDENuC1M0D',
            });
            this.$eventBus.closeModal();
            setTimeout(() => {
              window.location.href = 'https://motivac.io/thank-you.html'
            }, 700);
          })
          .catch((err) => {
            this.$swal(
              this.$t('registrate.error.title'),
              this.$t(`server.errors.${err.data.errorCode}`, {
                value: Object.keys(err.data.value)[0],
              }),
              'error'
            );
          });
      }
      // this.$eventBus.closeModal();
    },
    cancel() {
      this.$router.push({ name: 'AuthenticateScreen' });
    },
  },
};
</script>

<style lang="scss" scoped>
#registration-modal {
  
  padding: 20px;
  .row {
    margin: 10px 0;
    div[class*='col-']{
      padding-bottom: 15px;
    }
  }
  .cancel {
    color: $primary-color;
    cursor: pointer;
    &:hover {
      color: $secondary-color;
    }
  }
  .logo-container {
    font-size: 2rem;
    .logo {
      height: 50px;
    }
  }

  .main-title {
    font-size: 2rem;
  }
  .subtitle {
    opacity: 0.75;
  }
  .m-chckbox--container {
    margin-bottom: 0 !important;
  }
  >>> .m-chckbox--label {
    margin-bottom: 0 !important;
  }
  >>> .m-chckbox--group {
    >>> svg {
      margin-top: -5px;
    }
  }
  .hasError {
    color: $secondary-color;
    >>> a {
      color: $secondary-color;
      font-weight: bolder;
    }
  }
}
</style>

